/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react';

const NoSSR = (Component, loader = '') => function (props) {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) return loader;
  return <Component {...props} />;
};

export default NoSSR;
